import {
  AdminInfo,
  AuthResponse,
  UserCompleteProfile,
  UserSearchList,
  UserStatus,
} from "@/types";
import { ApiService, AxiosHeaders } from "@/services";
import { AxiosResponse } from "axios";
import { SuperAdminUser } from "@/types";

const USERS = 'users';
const USER = 'user';

class UserService {
  async getUserById(id: number): Promise<any> {
    return ApiService.api.get(`${USERS}/id/${id}`, {
      headers: AxiosHeaders.headersWithCredentials(),
    });
  }

  async updateProfile(input: AdminInfo): Promise<AdminInfo> {
    const { userId, ...body } = input;

    return ApiService.api.put(`${USERS}/profile`, body, {
      params: { userId },
      headers: AxiosHeaders.headersWithCredentials(),
    });
  }

  async deleteUser(
    user: number
  ): Promise<AxiosResponse<{ result: { userId: number; deleted: boolean } }>> {
    return ApiService.api.delete(USER, {
      headers: AxiosHeaders.headersWithCredentials(),
      data: { user },
    });
  }

  async toggleUserActivation(
    userId: string,
    action: UserStatus
  ): Promise<AxiosResponse<{ result: SuperAdminUser }>> {
    return ApiService.api.put(
      `${USERS}/activation/${action}/${userId}`,
      undefined,
      {
        headers: AxiosHeaders.headersWithCredentials(),
      }
    );
  }

  async completeProfile(
    userProfile: UserCompleteProfile
  ): Promise<AxiosResponse<{ result: AuthResponse }>> {
    return ApiService.api.post(`${USER}/profile`, userProfile);
  }

  async searchUser(
    offset?: number,
    limit?: number,
    search?: string
  ):Promise<AxiosResponse<{ result: UserSearchList }>>{
    return ApiService.api.get(`${USERS}/search/all`,{
      headers: AxiosHeaders.headersWithCredentials(),
      params: { offset, limit, search },

    })
  }
}
const singleton = new UserService();
export default singleton;
